/**
 * The Thoughts front matter, in one place.
 *
 * Matches the current Thoughts front matter:
 *
 *   title: "Post title"
 *   date: 2026-10-08
 *   summary: "A one or two sentence summary of what the post is about."
 *   tags: ["Tag", "Tag"]
 *
 * Changing it here is enough:
 * the Details form, the new-thought template and the sidebar all read this.
 * To add a draft field later, add { key: "draft", label: "Draft", type: "boolean" }.
 */
export type FieldType = "text" | "tags" | "date" | "boolean";
export interface Field {
  key: string;
  label: string;
  type: FieldType;
  /** Shown as a larger box in the form. */
  multiline?: boolean;
}
export interface Schema {
  fields: readonly Field[];
  required: readonly string[];
  titleKey: string;
  dateKey: string;
  tagsKey: string;
  tagsStyle: "flow" | "block";
  /** Whether new text values and new tags are written in double quotes. */
  quoteStrings: boolean;
}

export const THOUGHTS: Readonly<Schema> = Object.freeze<Schema>({
  fields: [
    { key: "title", label: "Title", type: "text" },
    { key: "date", label: "Publication date", type: "date" },
    { key: "summary", label: "Summary", type: "text", multiline: true },
    { key: "tags", label: "Tags", type: "tags" },
  ],
  /** A document is a Thought when its front matter has all of these keys. */
  required: ["title"],
  /** Key used for the sidebar title, and the key used for the sidebar date. */
  titleKey: "title",
  dateKey: "date",
  tagsKey: "tags",
  /** How a new tag list is written: "flow" is [a, b], "block" is a dash list. */
  tagsStyle: "flow",
  quoteStrings: true,
});
